export default __webpack_public_path__ + "static/media/QBERTSWAG.560fb320.png";